import React from "react";
import NativeBanner from "../NativeBanner/NativeBanner";

const Footer = () => {
  return (
    <>
      <NativeBanner/>
      <footer className="relative bg-transparent">
        <hr className="my-8 border-gray-600" />
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap text-left lg:text-left">
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top mb-6">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  {/* <span className="block uppercase text-white md:text-sm text-xs font-semibold mb-2">
                    Useful Links
                  </span> */}
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/submission"
                      >
                        Submission
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/skipline"
                      >
                        Skip the Line
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/ads"
                      >
                       More Streams
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  {/* <span className="block uppercase text-blueGray-500 md:text-sm text-xs font-semibold mb-2">
                    Useful Links
                  </span> */}
                  <ul className="list-unstyled">
                    {/* <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/"
                      >
                        Home
                      </a>
                    </li> */}
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/faq"
                      >
                        FAQ
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/get-stats"
                      >
                        Get Stats
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 md:text-sm text-xs"
                        href="/referral"
                      >
                        Referral
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">
                    Other Resources
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 text-sm"
                        href="https://github.com/creativetimofficial/notus-js/blob/main/LICENSE.md?ref=njs-profile"
                      >
                        MIT License
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/terms?ref=njs-profile"
                      >
                        Terms &amp; Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-blueGray-300 hover:text-blueGray-500 font-semibold block pb-2 text-sm"
                        href="https://creative-tim.com/privacy?ref=njs-profile"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
            <div className="flex flex-col md:pr-32 justify-between w-full lg:w-6/12 px-4 pb-6">
              <a
                className="hover:opacity-75 md:justify-end justify-center flex"
                href="https://www.instagram.com/soundoffcontests/"
                target="_blank"
                rel="noreferrer"
              >
                <span className="mt-1 md:text-lg text-xs text-white"> Instagram &nbsp;&nbsp;</span>
                <svg
                  className="md:w-9 md:h-9 w-6 h-6"
                  fill="white"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fillrule="evenodd"
                    d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                    cliprule="evenodd"
                  />
                </svg>
              </a>

              <span className="flex md:justify-end justify-center md:text-sm text-xs mt-6 mb-2 font-semibold text-white">
                Copyright &copy; <span id="get-current-year">&nbsp;2023&nbsp;</span> by SoundOff
                Music Inc.
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
